export function getAuditionSynopsisLabel(gigType?: string): string {
    return gigType?.trim().toLowerCase() === 'technical' ? 'Job description' : 'Synopsis';
}

export function getAuditionSynopsisPlaceholder(gigType?: string): string {
    return gigType?.trim().toLowerCase() === 'technical'
        ? 'Describe the role, deliverables, software or gear, timeline, and what success looks like...'
        : "Describe the project, characters, and what you're looking for...";
}

export const AUDITION_PLOT_PLACEHOLDER = 'Additional plot details, tone, or context for applicants...';

/** HTML fields that should always use RichTextEditor in dynamic forms. */
export const AUDITION_RICH_TEXT_STORE_KEYS = new Set(['synopsis', 'plot', 'description']);
